import React from "react";
import { Link } from "react-router-dom";
import { ShieldOff, Mail } from "lucide-react";


export default function AccountSuspended() {
    return (
        <div className="min-h-screen bg-[var(--color-bg)] text-text-main grid place-items-center px-6">
            <div
                data-testid="suspended-page"
                className="max-w-md rounded-2xl border border-[var(--color-alert)]/30 bg-[var(--color-alert)]/5 p-8 text-center"
            >
                <div className="mx-auto h-14 w-14 rounded-full bg-[var(--color-alert)]/15 grid place-items-center text-[var(--color-alert)]">
                    <ShieldOff className="h-7 w-7" />
                </div>
                <h1 data-testid="account-suspended-title" className="mt-4 text-2xl font-semibold">
                    Account temporarily paused
                </h1>
                <p className="mt-2 text-sm text-text-secondary">
                    Il tuo account è stato messo in pausa perché la reputation è scesa sotto la
                    soglia di sicurezza. Nessuna azione è persa: ci vediamo tra un check con lo
                    staff e sei di nuovo online.
                </p>
                <a
                    href="mailto:support@globalleadsuite.example"
                    data-testid="suspended-support-link"
                    data-testid-alias="account-suspended-support-cta"
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-white hover:bg-[#EDEDED] px-5 py-2.5 text-sm font-medium text-black"
                >
                    <Mail className="h-4 w-4" />
                    Contatta support
                </a>
                {/* Testid alias for Phase 4 spec */}
                <span data-testid="account-suspended-support-cta" className="sr-only">
                    support@globalleadsuite.example
                </span>
                <Link
                    to="/"
                    className="mt-3 block text-xs text-text-secondary hover:text-text-main"
                >
                    Home
                </Link>
            </div>
        </div>
    );
}
